@use "../zr-theme/zr-variables.scss" as *;

/**
 * @prop --zr-listing-gap: The gap between the container items.
 * @prop --zr-listing-grid-template-columns: Defines the grid-template-columns css property.
 * @prop --zr-listing-container-type: Defines the container-type css property.
 * @prop --zr-listing-container-name: Defines the container-name css property.
*/

.grid-container {
    display: grid;
    place-items: stretch stretch;

    gap: var(--zr-listing-gap, 2rem);
    grid-template-columns: var(--zr-grid-template-columns, 1fr);

    margin-bottom: var(--zr-grid-margin-bottom, 20px);

    container-type: var(--zr-listing-container-type, inline-size);
    container-name: var(--zr-listing-container-name, listing-container);
}

@media only screen and (min-width: $tablet-screen) {
    .grid-container {
        grid-template-columns: var(--zr-grid-template-columns-tablet, 1fr 1fr 1fr);
    }
}

@media only screen and (min-width: $desktop-screen) {
    .grid-container {
        grid-template-columns: var(--zr-grid-template-columns-desktop, 1fr 1fr 1fr 1fr);
    }
}
